import Image from "next/image";

import light from "../../public/images/light/switch/sun-01.svg";
import dark from "../../public/images/light/switch/vector.svg";

/**
 * Componente DarkSwitch que permite alternar entre el tema claro y oscuro.
 * Si el tema actual es claro (isLight es true), se muestra un botón que al pulsarlo
 * cambiará al tema oscuro, y viceversa.
 *
 * @param {Object} props - Props del componente.
 * @param {boolean} props.isLight - Indica si el tema actual es claro.
 * @param {Function} props.switchTheme - Función que se invoca para cambiar el tema.
 * @returns {JSX.Element} - Renderizado del conmutador de tema.
 */
const DarkSwitch = ({ isLight, switchTheme }) => {
  return (
    <div id="my_switcher" className="my_switcher">
      <ul onClick={switchTheme}>
        {isLight ? (
          <li>
            <button data-theme="light" className="setColor light">
              <Image src={dark} alt="Sun images" />
            </button>
          </li>
        ) : (
          <li>
            <button data-theme="dark" className="setColor dark">
              <Image src={light} alt="Vector Images" />
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default DarkSwitch;
